import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BackButtonDirective } from './backButton/back-button.directive';
import { NgForTrackByDirective } from './ngForTrackBy/ng-for-track-by.directive';

@NgModule({
  declarations: [BackButtonDirective, NgForTrackByDirective],
  imports: [
    CommonModule
  ],
  exports: [BackButtonDirective, NgForTrackByDirective]
})
export class DirectivesModule { }
